export default __webpack_public_path__ + "static/media/Vacanted_LOGO_header.18e36d87.png";